
import React from "react";
import "./MasterModule.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const buttons = [
  { label: "DentalAtt", color: "#ffadad", route: "/dental-att" },
  { label: "AdminAtt", color: "#ffd6a5", route: "/admin-att" },
  { label: "CDOEAtt", color: "#fdffb6", route: "/cdoe-att" },
  { label: "Attendance", color: "#9bf6ff", route: "/attendance" },
  { label: "Display Daily Attendance", color: "#a0c4ff", route: "/display-daily-attendance" },
  { label: "LeaveDetails", color: "#bdb2ff", route: "/leave-details-office" },
  { label: "PendingVerifications", color: "#ffc6ff", route: "/pending-verifications" },
  { label: "EmpList", color: "#fffffc", route: "/employee-list" },
  { label: "Departments", color: "#f1c0e8", route: "/members-list" },
  { label: "MembersList", color: "#ff8c61", route: "/fellows-list" },
  { label: "CollegeTeachersList", color: "#8ecae6", route: "/college-teachers-list" },
  { label: "ShiftEmp", color: "#b5ead7", route: "/shift-employee" },
  { label: "SpecialRoles", color: "#ffb4a2", route: "/special-roles" },
  { label: "DepartmentalRoles", color: "#bde0fe", route: "/departmental-roles" },
  { label: "Student Registration (Instructions)", color: "#cdb4db", route: "/student-registration-instructions" },
  { label: "Student Registration Temporarily Closed", color: "#f08080", route: "/student-registration-closed" },
  { label: "StuRegi", color: "#f9f871", route: "/student-registration" },
  { label: "Directory", color: "#b2f7ef", route: "/directory" },
  { label: "Switch Roles", color: "#f7d6e0", route: "/switch-roles" },
  { label: "NewItem", color: "#d0f4de", route: "/new-item" },
  { label: "Logout", color: "#ffbaba", route: "/logout" },
];

export default function MasterModule() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Define allowed role IDs (example: [1, 7, 13, 16])
  const ALLOWED_ROLE_IDS = [1, 7, 13, 16]; // Update as per your role_master
  const userRoleId = parseInt(user?.moduleId, 10);

  if (!ALLOWED_ROLE_IDS.includes(userRoleId)) {
    return (
      <div className="master-module-container">
        <h2>Unauthorized</h2>
        <p>You do not have access to this module.</p>
      </div>
    );
  }

  const handleButtonClick = (route) => {
    navigate(route);
  };

  return (
    <div className="master-module-container">
      <div className="master-module-buttons">
        {buttons.map((btn, idx) => (
          <button
            key={idx}
            className="master-module-btn"
            style={{ backgroundColor: btn.color }}
            onClick={() => handleButtonClick(btn.route)}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}